// Import Packages
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from 'uuid';

// Import Recoil State
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    activeItemsAtom, alertState, openDesktopRecordAtom, scopedImageAtom, desktopActiveItemsAtom,
    quickActionsAtom, saveAvailable, changedFields, desktopActionWaitingList, triggerConf
} from "../../../../../recoil-store/recoil-state";

// Import Material UI
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, TextField } from "@material-ui/core/";

// Import Pages
import MiddleArea from "../../../../../home/pages/automs/newFlow/middleArea/MiddleArea";
import LeftArea from "../../../../../home/pages/automs/newFlow/leftArea/LeftArea";
import RightArea from './../../../../../components/FlowConfigurationForms';
import CaptureArea from "../../../../CaptureArea/CaptureArea";
import SelectAction from "./components/SelectAction/SelectAction";
import SimulateModal from "./components/SimulateModal/SimulateModal";
import NewScopeModal from "./components/NewScopeModal/NewScopeModal";
import ConnectorField from "../../../../../home/pages/automs/newFlow/middleArea/connectorField/ConnectorField";
import Guide from "../../../../CaptureArea/Guide/Guide";

// import EventConfiguration from '../../../FlowConfigurationInputs/EventConfiguration/EventConfiguration';

// Import Icons
import Close from "@material-ui/icons/Close";
import uiActionsIcon from '../../../../../assets/icons/moduleIcons/ui-actions-icon.svg'
import maximizeIcon from '../../../../../assets/icons/maximize-icon.svg'

// Import CSS
import './DesktopActions.css';
import '../../../../../home/pages/automs/newFlow/leftArea/ModuleItem/ModuleItem.css'
import '../../../../../home/pages/automs/newFlow/NewFlow.css';
import '../../../../../home/pages/automs/newFlow/middleArea/dropArea/item/Item.css';

// import '../../../../../home/pages/automs/newFlow/leftArea/LeftArea.css'

// Import Services
import AutomService from "../../../../../services/AutomService/AutomService";
import ActionService from "../../../../../services/ActionService/ActionService";
import { BASE_ORIGIN } from '../../../../../services/config';



// Import Helpers
import { updateFlowItems, findParentActionById, findParentScopeById, getImageColors, getShade, getImageResolution, addDifference } from "../../../../../helpers/helper";


const DesktopActions = ({ automDetail,
    setAutomDetail,
    triggerDetail,
    setTriggerDetail,
    operationId,
    handleTrigger,
    handleDragStart,
    handleDragEnd,
    resetFlow,
    saveFlow,
    runFlow,
    debugFlow,
    tabFilter,
    setTabFilter,
    detailTabs,
    setDetailTabs,
    setDialog,
    editFlow,
    setOpenSchedule,
    setTriggerModal,
    triggerType,
    handleStart,
    handleStop,
    isRunning,
    trigger,
    setOpenDrive,
    publishFlow,
    debuggingStart,
    setDebuggingExpand,
    openRunningModal,
    setOpenDebugRunning,
    debuggingExpand,
    handleDiagramBuilder,
    handleRoi,
    findAndUpdateItem,
    isDiagramBuilder,
    diagramData,
    setIsDiagramBuilder,
    setOpenRoi,
    setShowRightArea,
    setShowTriggerRightArea,
    handleExport,
    handleImport,
    handleSlowMotion,
    setFlowStatus,
    handleErrorOpenClick,
    handleErrorCloseClick,
    variables,
    setOpenVariable,
    reCheck,
    setReCheck,
    openResetTriggerConfiguration,
    testAppStarted,
    handleTestAppCancel,
    automaticallyVariableCreation,
    automaticallyWhatsappVariableCreation,
    setIsWhatsappExist,
    setIsMSTeamsExist,
    getVariables,
    updateVariableByItemId,
    // setActiveItem,
    savedFlow,
    setVariables,
    openVariable,
    automType,
    automVersionId,
    automId,
    actions,
    action,
    setActions,
    paramsId,
    isEhFlow,
    setGroupLabel,
    recorder,
    drecorder
}) => {
    const [desktopAutomDetails, setDesktopAutomDetails] = useState(automDetail);
    const [desktopScreen, setDesktopScreen] = useState("");
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [imageEnlarged, setImageEnlarged] = useState(false);
    const [modalSS, setModalSS] = useState({});
    const [loading, setLoading] = useState(true);
    const [isRunningSimulate, setIsRunningSimulate] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [tempActions, setTempActions] = useState(JSON.parse(JSON.stringify(actions)));
    const [initialActions, setInitialActions] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [selectedAction, setSelectedAction] = useState({});
    const [paginationArea, setPaginationArea] = useState(false);
    const [uniqueColumnAreas, setUniqueColumnAreas] = useState(false);
    const [activeAreaSelector, setActiveAreaSelector] = useState("");
    const setScopedImage = useSetRecoilState(scopedImageAtom);
    const [desktopActiveItems, setDesktopActiveItems] = useRecoilState(desktopActiveItemsAtom);
    const [openSimulatedScopeModal, setOpenSimulatedScopeModal] = useState(false);
    const [openAddClicked, setOpenAddClicked] = useState({ status: false });
    const [checkSimulatePendingMessage, setCheckSimulatePendingMessage] = useState(false);
    const quickActionsLibrary = useRecoilValue(quickActionsAtom);
    const [baseOrigin, setBaseOrigin] = useState("");
    const { t } = useTranslation();
    const setOpenDesktopRecord = useSetRecoilState(openDesktopRecordAtom);
    const setAlert = useSetRecoilState(alertState);
    const [getDesktopActionWaitingList, setDesktopActionWaitingList] = useRecoilState(desktopActionWaitingList);
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);

    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);


    const label = 'CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.SCOPE.';
    const defaultLibraryImg = `default_library.png`


    useEffect(() => {
        getBaseOrigin()
        const fetchData = async () => {
            let dataString = await getSs(action)
            // action.fields.getSS.value = dataString
            tempActions[action.id].fields.getSS = { value: dataString }
            // setTempActions(JSON.parse(JSON.stringify(actions)))
            // if (action) {
            //     setSelectedAction(JSON.parse(JSON.stringify(action)))
            //     setDesktopActiveItems([JSON.parse(JSON.stringify(action))])
            // }

            // >>>>>>> 703b0eedf37aa5f40723ac88ca899b42c89a43ee
            return dataString
        }

        const fetchElements = async (dataString) => {
            let responseDataJson = await getElementsHighlight(dataString, action)
            //action.fields.highlightElements = { value: responseDataJson }
            tempActions[action.id].fields.highlightElements = { value: responseDataJson }
        }

        const startFetch = async () => {
            let dataString;
            if (!action.fields?.getSS?.value) {
                dataString = await fetchData();

                // if (!getDesktopActionWaitingList[action.item_id]) {
                //     setDesktopActionWaitingList(prew => ({
                //         ...prew,
                //         [action.item_id]: true
                //     }));

                // }
            }
            else {
                setDesktopScreen(action.fields.getSS.value)
            }
            if (!action.fields?.highlightElements) {
                await fetchElements(dataString)
                // if (!getDesktopActionWaitingList[action.item_id]) {
                //     dataString = dataString ? dataString : action.fields.getSS.value

                // }
            }


            setLoading(false)
        }

        if (action?.actionName === "SCOPE") {
            //setTempActions(JSON.parse(JSON.stringify(actions)))
            if (action) {
                // setSelectedAction(JSON.parse(JSON.stringify(action)))
                setDesktopActiveItems([JSON.parse(JSON.stringify(action))])
            }

            startFetch()
        }
        else {
            if (action) {
                openActionFromNewFlow()

                // setTempActions(JSON.parse(JSON.stringify(actions)))
                // setSelectedAction(JSON.parse(JSON.stringify(action)))
                setDesktopActiveItems([JSON.parse(JSON.stringify(action))])
            }

        }
    }, [])

    const getBaseOrigin = async () => {
        const baseOr = await BASE_ORIGIN;
        setBaseOrigin(baseOr)

        // Centering which action is opened
        const _id = action.item_id ? action.item_id : action.id;
        const flow = document.querySelector(`.dialog-desktop-actions #act_${_id}`);
        if (flow) {
            flow.scrollIntoView({
                block: "center",
                inline: "center",
            });
            flow.style.backgroundColor = "#80808025";
            setTimeout(() => {
                flow.style.backgroundColor = "";
            }, 1000)
        }
    }

    const getSs = async (_action, isShowPreviewScope) => {
        // Get Desktop SS
        let manipulatedAction = JSON.parse(JSON.stringify(_action));
        manipulatedAction.children = [];
        manipulatedAction.automId = automId;
        manipulatedAction.automVersionId = automVersionId;
        let resp = await AutomService.runAction(manipulatedAction);
        if (!resp) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.GENERAL.NETWORK-ERROR"),
                severity: 'error'
            }))
        }
        else if (!resp.status) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.LIBRARY." + resp.message),
                severity: 'error'
            }))
        }
        let dataString = "data:image/jpeg;base64," + resp.dataString;
        // setDesktopScreen("data:image/jpeg;base64," + resp.dataString)
        if (!isShowPreviewScope) setDesktopScreen(dataString)
        // if (!action.fields?.getSS?.value) {
        //     action.fields.getSS.value = "data:image/jpeg;base64," + resp.dataString
        // }
        return dataString;
    }

    const getElementsHighlight = async (dataString, _action) => {
        let responseDataJson
        let manipulatedAction = JSON.parse(JSON.stringify(_action));
        manipulatedAction.children = [];
        manipulatedAction.automId = automId;
        manipulatedAction.automVersionId = automVersionId;

        manipulatedAction.fields.imgURL = { value: dataString }
        manipulatedAction.fields.elements = { value: true }
        await getImageResolution(dataString).then(({ width, height }) => {
            manipulatedAction.fields.resolution = { value: { width, height } }
        });
        const response = await AutomService.getClickedArea({ action: manipulatedAction, operationId: uuidv4() });
        const responseData = response.dataString
        if (responseData) {
            responseDataJson = JSON.parse(responseData);
        }
        if (!response) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.GENERAL.NETWORK-ERROR"),
                severity: 'error'
            }))
        }
        else if (!response.status) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.LIBRARY." + response.message),
                severity: 'error'
            }))
        }
        return responseDataJson
    }
    // const getSs = async () => {
    //     debugger;
    //     // Get Desktop SS
    //     let manipulatedAction = JSON.parse(JSON.stringify(action));
    //     manipulatedAction.children = [];
    //     manipulatedAction.automId = automId;
    //     manipulatedAction.automVersionId = automVersionId;
    //     let resp = await AutomService.runAction(manipulatedAction);
    //     if (!resp) {
    //         return setAlert(alert => ({
    //             ...alert,
    //             show: true,
    //             message: t("MESSAGES.GENERAL.NETWORK-ERROR"),
    //             severity: 'error'
    //         }))
    //     }
    //     else if (!resp.status) {
    //         return setAlert(alert => ({
    //             ...alert,
    //             show: true,
    //             message: t("MESSAGES.LIBRARY." + resp.message),
    //             severity: 'error'
    //         }))
    //     }
    //     setDesktopScreen("data:image/jpeg;base64," + resp.dataString)
    //     setLoading(false)
    //     if (!action.fields?.getSS?.value) {
    //         action.fields.getSS.value = "data:image/jpeg;base64," + resp.dataString
    //     }
    // }
    // useEffect(() => {
    //     if (desktopScreen) {
    //         selectedAction.fields.getSS.value = desktopScreen
    //     }
    // }, [desktopScreen])
    useEffect(() => {
        if (desktopActiveItems.length > 0) {
            let item;
            item = JSON.parse(JSON.stringify(desktopActiveItems[0]))
            const oldActiveActionsEl = document.querySelectorAll(`.dialog-desktop-actions .border-active-action`);
            for (const el of oldActiveActionsEl) {
                el.classList.remove("border-active-action")
            }
            // Adding active displaying class for activeItem element
            if (item && desktopActiveItems.length) {
                const _id = item.item_id ? item.item_id : item.id;
                const flow = document.querySelector(item.actionName === "START" ? `.dialog-desktop-actions #start-container-border` : `.dialog-desktop-actions #new-flow-drop-area-grid #act_${_id} > div`);
                if (flow) {
                    flow.classList.add("border-active-action")
                }
            }
            if (item && item.fields && action.id !== item.id && (!tempActions[item.id] || (tempActions[item.id]?.fields?.getSS && !tempActions[item.id]?.fields?.getSS.value))) {
                let id = JSON.parse(JSON.stringify(item.id))
                let label = item?.library_label?.includes('CUSTOM') ? item?.action_name : t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);

                const init = async () => {
                    let isEndFecth = false;
                    if (item.actionName === "SCOPE") {
                        if (getDesktopActionWaitingList[item.item_id]) {
                            return
                        }

                        setLoading(true)
                        setDesktopActionWaitingList(prev => ({
                            ...prev,
                            [item.item_id]: "wait"
                        }));
                        let dataString;
                        if (item.fields.getSS?.value) {
                            dataString = item.fields.getSS.value
                        }
                        else {
                            dataString = await getSs(item)
                        }
                        if (dataString) {
                            item.fields.getSS = { value: dataString }
                            //setDesktopScreen(dataString)
                            let responseDataJson = await getElementsHighlight(dataString, item)
                            if (responseDataJson) {
                                item.fields.highlightElements = { value: responseDataJson }

                            }

                            if (desktopActiveItems && desktopActiveItems.length && desktopActiveItems[0].item_id === item.item_id) {
                                setDesktopScreen(JSON.parse(JSON.stringify(dataString)))
                            }
                            isEndFecth = true;
                        }

                        setLoading(false)
                    } else if (item.libraryName === "DESKTOP-ACTIONS") {
                        getParentScopeById(item.item_id, desktopAutomDetails.items, true).then(r => r);
                    }

                    setTempActions(prev => ({
                        ...prev,
                        [id]: {
                            ...prev[id],
                            fields: JSON.parse(JSON.stringify(item.fields)),
                            actionName: JSON.parse(JSON.stringify(item.actionName)),
                            libraryName: JSON.parse(JSON.stringify(item.libraryName)),
                            application_id: item.application_id ? JSON.parse(JSON.stringify(item.application_id)) : null,
                            isDebugging: JSON.parse(JSON.stringify(item.isDebugging)),
                            autom_id: item?.autom_id?.length > 0 ? JSON.parse(JSON.stringify(item.autom_id)) : null,
                            libraryLabel: JSON.parse(JSON.stringify(item.library_label)),
                            id,
                            item_id: item.item_id,
                            image: item?.image,
                            actionId: item.actionId ? JSON.parse(JSON.stringify(item.actionId)) : "",
                            inputs: item.inputs ? JSON.parse(JSON.stringify(item.inputs)) : null,
                            label
                        }
                    }))

                    if (isEndFecth) {
                        setDesktopActionWaitingList(prev => {
                            const newData = { ...prev };
                            if (newData[item.item_id]) {
                                delete newData[item.item_id];
                            }
                            return newData;
                        });
                    }

                }
                init()

            }
            if (item.actionName === "FIND-AND-CLICK" && tempActions[item.id] && tempActions[item.id].fields && tempActions[item.id].fields.imgURL && tempActions[item.id].fields.imgURL.value) {
                // setDesktopScreen(tempActions[item.id].fields.imgURL.value)
            }
            if (tempActions[item.id]) {
                if (tempActions[item.id].actionName === "SCOPE") {

                    if (tempActions[item.id].fields?.getSS?.value) {
                        setDesktopScreen(tempActions[item.id].fields.getSS.value)
                        setLoading(false)
                    } else {
                        setDesktopScreen("");
                    }
                } else if (tempActions[item.id].libraryName === "DESKTOP-ACTIONS") {
                    getParentScopeById(tempActions[item.id].item_id, desktopAutomDetails.items, true).then(r => r);
                    setLoading(false)
                }
                else {
                    setDesktopScreen("")
                    setLoading(false)
                }

            }
            else {
                setDesktopScreen("")
            }
        }
        else {
            setDesktopScreen("")
        }


    }, [desktopActiveItems])

    useEffect(() => {
        const dashedLineStyleCalculator = () => {
            const parent = document.querySelectorAll('.option-condition');
            parent.forEach((optionConditionElement) => {
                const optionContainerElement = optionConditionElement.querySelectorAll('.condition-container');
                if (optionContainerElement.length > 0) {
                    optionContainerElement.forEach(conditionElement => {
                        const nextElement = conditionElement.nextSibling
                        if (nextElement?.classList.value.includes("dashed-connect")) {
                            const dashedLine = conditionElement.querySelector(`.dashed-connect-line`)
                            const parentElement = dashedLine.parentElement
                            const parentElementWidth = parentElement.offsetWidth
                            const nextElementWidth = nextElement.offsetWidth
                            dashedLine.classList.remove("d-n")
                            dashedLine.style.left = parentElementWidth / 2 + "px"
                            dashedLine.style.width = (parentElementWidth / 2) + 60 + (nextElementWidth - (60)) / 2 + "px"
                        }
                        else {
                            const dashedLine = conditionElement.querySelector(`.dashed-connect-line`)
                            if (dashedLine) {
                                dashedLine.classList.add("d-n")
                            }
                        }
                    })
                }
            });
        }
        const horizontalLineStyleCalculator = () => {
            const iconWidth = 60;
            const staticAdditionalWidth = 8;
            const staticAdditionalLeft = 5;
            const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
            Array.prototype.forEach.call(conditionHoverLines, function (el) {
                // Do stuff here
                const sEl = findAncestor(el, "horizontal-condition-row");
                const leftPosition = (sEl.offsetWidth / 2) + (iconWidth / 2) + staticAdditionalLeft;
                const actualWidth = (sEl.offsetWidth - leftPosition) + staticAdditionalWidth;
                el.style.width = actualWidth + "px";
                el.style.left = leftPosition + "px";
            });
        }
        const intervalId = setInterval(() => {
            const parent = document.querySelectorAll('.option-condition');
            if (parent && parent.length) {
                dashedLineStyleCalculator()
                clearInterval(intervalId)
            }
        }, 200);
        const intervalLine = setInterval(() => {
            const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
            if (conditionHoverLines && conditionHoverLines.length) {
                horizontalLineStyleCalculator()
                clearInterval(intervalLine)
            }
        }, 200);
        setTimeout(() => {
            clearInterval(intervalLine)
            clearInterval(intervalId)
        }, 2000);
    }, [desktopAutomDetails.items])

    function findAncestor(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    }

    const getParentScopeById = async (item_id, items, is_root) => {
        const parentScope = await findParentScopeById(item_id, items, is_root)
        if (parentScope) {
            const parentScopeObj = tempActions[parentScope.id]
            if (parentScopeObj && parentScopeObj.fields?.getSS?.value) {
                setDesktopScreen(parentScopeObj.fields.getSS.value);
            }
        }

    }

    const handleActions = useCallback((item) => {
        if (item && item.fields && !tempActions[item.id]) {
            let id = JSON.parse(JSON.stringify(item.id))
            let label = item?.library_label?.includes('CUSTOM') ? item?.action_name : t(`CONTENT.LIBRARY.${item.libraryName}.ACTION.${item.name}`);
            setTempActions(prev => ({
                ...prev,
                [id]: {
                    ...prev[id],
                    fields: JSON.parse(JSON.stringify(item.fields)),
                    actionName: JSON.parse(JSON.stringify(item.actionName)),
                    libraryName: JSON.parse(JSON.stringify(item.libraryName)),
                    application_id: item.application_id ? JSON.parse(JSON.stringify(item.application_id)) : null,
                    isDebugging: JSON.parse(JSON.stringify(item.isDebugging)),
                    autom_id: item?.autom_id?.length > 0 ? JSON.parse(JSON.stringify(item.autom_id)) : null,
                    libraryLabel: JSON.parse(JSON.stringify(item.library_label)),
                    id,
                    item_id: item.item_id,
                    image: item?.image,
                    actionId: item.actionId ? JSON.parse(JSON.stringify(item.actionId)) : "",
                    inputs: item.inputs ? JSON.parse(JSON.stringify(item.inputs)) : null,
                    label
                }
            }))
        }
    }, [tempActions])

    const setDesktopActiveItem = useCallback((e, item, config, type = 'normal') => {

        if (type === 'debug') {
            let active = JSON.parse(JSON.stringify(item));
            setDesktopActiveItems([{
                ...active,
                actionName: active.action_name,
                libraryName: active.library_name,
                libraryLabel: active.library_label,
                isDebugging: !active.isDebugging,
            }])
        } else {
            let activeItem, exist, selected = {
                ...item,
                actionName: item.action_name,
                libraryName: item.library_name,
                libraryLabel: item.library_label,
            };

            if (e?.ctrlKey) {
                activeItem = desktopActiveItems.filter(i => {
                    if (i.id === item.id) {
                        exist = true;
                        return false;
                    } else return true;
                });
                if (!exist) activeItem.push(selected);
            } else activeItem = [selected];
            setDesktopActiveItems(activeItem)


        }
    }, [desktopAutomDetails.items]);

    const openAddActionsByClickDialog = useCallback((e, clickedItem) => {
        setOpenAddClicked({ status: true, clickedItem })
        // handleQuickActionClick(e, copyItem, parentItemId)
    }, [])

    const handleQuickActionClick = (e, copyItem, parentItemId) => {
        let item = JSON.parse(JSON.stringify(copyItem))
        item.item_id = uuidv4();
        item.id = uuidv4();

        if (e?.stopPropagation) e.stopPropagation();
        if (e?.stopPropagation)
            e.stopPropagation();

        localStorage.setItem("dragItem", JSON.stringify({ item, isMove: false }));
        // let parentItemId = desktopActiveItems[0]?.item_id

        let dropZone = document.getElementById(`parent-id-${parentItemId}`)
        if (dropZone) {
            const dropEvent = new DragEvent("drop", { bubbles: true, cancelable: true });
            dropZone.dispatchEvent(dropEvent);
        }
    }

    const handleScale = () => {
        if (!imageEnlarged) {
            if (!imageEnlarged) {
                const image = document.querySelector(".desktop-screen-image")
                const width = image.offsetWidth + "px"
                const height = image.offsetHeight + "px"
                return { width: `${width}`, height: `${height}` }
            }
        }
    }

    const handleCloseDialog = () => {
        if (isFullScreen) {
            setIsFullScreen(false)
            setImageEnlarged(false)
            return
        }
        setOpenDesktopRecord(false);
        setDesktopActiveItems([])
    };

    // set original automDetail after save
    const updateAutom = () => {
        let tmpActions = JSON.parse(JSON.stringify(tempActions))
        let copyItems = JSON.parse(JSON.stringify(desktopAutomDetails.items))
        updateFlowItems(copyItems, tmpActions, tmpActions)
        let details = JSON.parse(JSON.stringify(desktopAutomDetails))
        details.items = copyItems;

        setAutomDetail(details)
        // setScopedImage(desktopScreen)
        // action.fields.getSS.value = desktopScreen;
        //if (selectedItem.id) {
        // setActions(JSON.parse(JSON.stringify(initialActions)))
        setActions(JSON.parse(JSON.stringify(tmpActions)))
        // }
        // setActiveItem(desktopActiveItems[0])

        // open save icon for flow
        const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));

        addDifference(cfTemp, action, 'changedRecord', setChangeFields, setSaveAvailable)


        // if (!oldValue) {
        //     addDifference(cfTemp, action, 'attributes', setChangeFields, setSaveAvailable)
        // } else {
        //     if (checkTheDifference(newValue, oldValue)) {
        //         addDifference(cfTemp, action, 'attributes', setChangeFields, setSaveAvailable)
        //     } else {
        //         removeDifference(cfTemp, action, 'attributes', setChangeFields, setSaveAvailable)
        //     }
        // }
        return setAlert(alert => ({
            ...alert,
            show: true,
            message: t("MESSAGES.AUTOMS.AUTOM-SAVED"),
            severity: 'success'
        }))
    };

    const handleMaximizeScreen = () => {
        setIsFullScreen(true)
        setTimeout(() => {
            setImageEnlarged(true)
        }, 1);
    }
    const desktopActionsEditDialog = useCallback((item) => {
        setOpenEdit(true)
        setSelectedItem(item)
        setInitialActions(JSON.parse(JSON.stringify(tempActions)))
    }, [tempActions])
    const handleCloseEdit = () => {
        // ToDo EMIRHAN BAKACAK
        // setTempActions(JSON.parse(JSON.stringify(initialActions)))
        setOpenEdit(false)
    }

    const handleSaveEdit = () => {
        setInitialActions(JSON.parse(JSON.stringify(tempActions)))
        // setTempActions(JSON.parse(JSON.stringify(initialActions)))
        setOpenEdit(false)
        return setAlert(alert => ({
            ...alert,
            show: true,
            message: t("MESSAGES.AUTOMS.AUTOM-SAVED"),
            severity: 'success'
        }))
    }

    const handleDeleteAction = useCallback((id) => {
        const getSS = tempActions[id]?.fields?.getSS?.value
        if (desktopScreen === getSS) {
            setDesktopScreen("")
        }
    }, [desktopScreen, tempActions])

    const openActionFromNewFlow = async () => {
        // let tmpActions = JSON.parse(JSON.stringify(actions))
        let copyItems = JSON.parse(JSON.stringify(desktopAutomDetails.items))
        // updateFlowItems(copyItems, tmpActions, tmpActions)
        let activeAction = JSON.parse(JSON.stringify(action))
        let scopeItem = await findParentScopeById(activeAction.item_id, copyItems, true)
        if (action.fields?.imgURL.value) {
            setDesktopScreen(action.fields.imgURL.value)
            setLoading(false)
            handleMaximizeScreen()
        }
        else if (scopeItem && scopeItem.fields.getSS.value) {
            setLoading(false)
            setDesktopScreen(scopeItem.fields.getSS.value)
            if ((action.actionName === "FIND-AND-INPUT" || action.actionName === "FIND-AND-CLICK" || action.actionName === "HOVER" || action.actionName === "ELEMENT-EXIST") && action.fields?.destination?.value) {
                handleMaximizeScreen()
            }
            else if ((action.actionName === "GET-TEXT" || action.actionName === "CROP-IMAGE") && action.fields?.completedCropOffset?.value) {
                handleMaximizeScreen()
            }
            else if (action.actionName === "PAGINATION" && action.fields?.completedCropOffset?.value) {
                handleMaximizeScreen()
            }
        } else {
            setDesktopScreen("")
            setLoading(false)
        }
    }

    const handleSimulate = async () => {
        if (checkDisabledSimulate()) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.LIBRARY.NOT-ALLOWED"),
                severity: 'error'
            }))
        }

        setIsRunningSimulate(true);

        // simutelate yapılmabilmek için 4 actiondan birinde aktif olmam lazım.

        let tmpActions = JSON.parse(JSON.stringify(tempActions))
        let copyItems = JSON.parse(JSON.stringify(desktopAutomDetails.items))
        updateFlowItems(copyItems, tmpActions, tmpActions)
        let simulatedAction = JSON.parse(JSON.stringify(tempActions[desktopActiveItems[0].id]))
        delete simulatedAction.fields.imgURL
        let scopeItem = await findParentActionById(desktopActiveItems[0].item_id, copyItems, true)

        if (simulatedAction.actionName !== "SCOPE" && scopeItem) {
            if (scopeItem.actionName === 'PAGINATION-ITEM' || scopeItem.actionName === 'POST-PAGINATION') {
                scopeItem = await findParentScopeById(desktopActiveItems[0].item_id, copyItems, true)
            }
            scopeItem.children = [simulatedAction];
            delete scopeItem.fields.getSS
            delete scopeItem.fields.highlightElements
        }

        // = tempActions[desktopActiveItems[0].id]
        //let manipulatedAction = JSON.parse(JSON.stringify(scopeActionChanged.data));
        //let manipulatedAction = JSON.parse(JSON.stringify(simulatedAction));

        scopeItem.automId = automId;
        scopeItem.automVersionId = automVersionId;
        //setDesktopScreen("")
        // setLoading(true)
        if (simulatedAction.actionName === "SCOPE") {
            setCheckSimulatePendingMessage(true)
            const dataString = await getSs(simulatedAction)
            if (dataString) {
                simulatedAction.fields.getSS = { value: dataString }
                tempActions[desktopActiveItems[0].id].fields.getSS = { value: dataString }
                //setDesktopScreen(dataString)
                let responseDataJson = await getElementsHighlight(dataString, simulatedAction)
                if (responseDataJson) {
                    simulatedAction.fields.highlightElements = { value: responseDataJson }
                    tempActions[desktopActiveItems[0].id].fields.highlightElements = { value: responseDataJson }
                }

                if (desktopActiveItems && desktopActiveItems.length && desktopActiveItems[0].item_id === simulatedAction.item_id) {
                    setDesktopScreen(JSON.parse(JSON.stringify(dataString)))
                }
                setIsRunningSimulate(false);
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.AUTOMS.DESKTOP-RECORDER.SCOPE-RETAKE"),
                    severity: 'success'
                }))
            }
        } else {
            scopeItem.mate_id = automDetail.mate_id;
            setCheckSimulatePendingMessage(false)
            let resp = await AutomService.runAction(scopeItem);
            setIsRunningSimulate(false);
            if (!resp) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.GENAREL.NETWORK-ERROR"),
                    severity: 'error'
                }))
            }
            else if (!resp.status) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.LIBRARY." + resp.message),
                    severity: 'error'
                }))
            } else {
                // let dataString = "data:image/jpeg;base64," + resp.dataString;
                let dataString = await getSs(scopeItem, true)
                setModalSS({ dataString, scopeItem })
                setOpenSimulatedScopeModal(true)
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.AUTOMS.DESKTOP-RECORDER.SIMULATION-COMPLETED"),
                    severity: 'success'
                }))
            }
        }



        // scopeItem.children = [];
        // let [dataString, responseDataJson] = await getSs(scopeItem)
        // let parentScopeId = scopeItem.id;
        // scopeItem.fields.getSS = { value: dataString };
        // scopeItem.fields.highlightElements = { value: responseDataJson };
        // delete scopeItem.fields.automId;
        // delete scopeItem.fields.automVersionId;

        // scopeItem.id = uuidv4();
        // scopeItem.item_id = uuidv4();
        // let cpyItems = JSON.parse(JSON.stringify(desktopAutomDetails.items))
        // const isSuccess = addNewScope(cpyItems, parentScopeId, scopeItem);
        // if (isSuccess) {
        //     // burada alt tarafta sadece items değeri güncellenmeli.
        //     setDesktopAutomDetails({
        //         ...desktopAutomDetails, items: cpyItems
        //     });
        //     // setDesktopAutomDetails(cpyItems);
        //     setDesktopScreen(dataString);
        //     setDesktopActiveItem({}, scopeItem)
        // }

        //setDesktopScreen("data:image/jpeg;base64," + resp.dataString)
        // setLoading(false)
    }

    const handleAddNewScope = () => {
        const scopeItem = modalSS.scopeItem
        scopeItem.children = [];
        // let [dataString, responseDataJson] = await getSs(scopeItem)
        let parentScopeId = scopeItem.id;
        // scopeItem.fields.getSS = { value: dataString };
        scopeItem.fields.getSS = { value: modalSS.dataString };
        // scopeItem.fields.highlightElements = { value: responseDataJson };
        delete scopeItem.fields.automId;
        delete scopeItem.fields.automVersionId;

        scopeItem.id = uuidv4();
        scopeItem.item_id = uuidv4();
        let cpyItems = JSON.parse(JSON.stringify(desktopAutomDetails.items))
        const isSuccess = addNewScope(cpyItems, parentScopeId, scopeItem);
        if (isSuccess) {
            // burada alt tarafta sadece items değeri güncellenmeli.
            setDesktopAutomDetails({
                ...desktopAutomDetails, items: cpyItems
            });
            // setDesktopAutomDetails(cpyItems);
            // setDesktopScreen(dataString);
            setDesktopActiveItem({}, scopeItem)
        }
        setOpenSimulatedScopeModal(false)
        setModalSS({})
        // setDesktopScreen("data:image/jpeg;base64," + resp.dataString)
        // setLoading(false)
    }

    const addNewScope = (items, id, newItem) => {
        let matched = false;

        items.forEach((item, index) => {
            if (item.id === id) {
                matched = true;
                items.splice(index + 1, 0, { ...newItem });
                return;
            } else if (!matched && item.children) {
                matched = addNewScope(item.children, id, newItem);
                if (matched) {
                    return true;
                }
            }
        });
        return matched;
    }

    const checkDisabledSimulate = () => {
        if (desktopActiveItems && desktopActiveItems[0]?.id) {
            const selectedAction = tempActions[desktopActiveItems[0]?.id];
            if (!selectedAction) {
                return true;
            }

            switch (selectedAction.actionName) {
                case 'SCOPE':
                    return false;
                case 'FIND-AND-CLICK':
                case 'HOVER':
                    if (selectedAction.fields && selectedAction.fields.source?.value && selectedAction.fields.resolution?.value &&
                        selectedAction.fields.cropImg && selectedAction.fields.difference?.value && selectedAction.fields.mouseType &&
                        selectedAction.fields.highlightedElements?.value?.clickedObj?.length && selectedAction.fields.highlightedElements?.value?.neighbourObj?.length) {
                        return false;
                    }
                    break;
                case 'FIND-AND-INPUT':
                    if (selectedAction.fields && selectedAction.fields.inputValue?.value && selectedAction.fields.cropImg &&
                        selectedAction.fields.highlightedElements?.value?.clickedObj?.length && selectedAction.fields.highlightedElements?.value?.neighbourObj?.length) {
                        return false;
                    }
                    break;

                case 'ELEMENT-EXIST':
                    if (selectedAction.fields && selectedAction.fields.completedCrop && selectedAction.fields.completedCrop.value?.length && selectedAction.fields.set?.value &&
                        selectedAction.fields.highlightedElements?.value?.clickedObj?.length && selectedAction.fields.highlightedElements?.value?.neighbourObj?.length) {
                        return false;
                    }
                    break;
                case 'GET-TEXT':
                case 'PAGINATION':
                case 'CROP-IMAGE':
                    if (selectedAction.fields && selectedAction.fields.completedCrop && selectedAction.fields.completedCrop.value?.length && selectedAction.fields.set?.value) {
                        return false;
                    }
                    break;
                case 'KEY-TAP':
                case 'KEY-PRESS':
                    if (selectedAction.fields && selectedAction.fields.value?.value) return false;
                    break;
                case 'KEY-COMBINATION':
                    if (selectedAction.fields && (selectedAction.fields.value?.value || selectedAction.fields?.enterTrigger?.value)) return false;
                    break;
                case 'SCROLL-UP':
                case 'SCROLL-DOWN':
                    if (selectedAction.fields && selectedAction.fields.incrementState?.value) return false;
                    break;
                case 'SMOOTH-SCROLL':
                    if (selectedAction.fields && selectedAction.fields.incrementStateSmooth?.value && selectedAction.fields.duration?.value &&
                        selectedAction.fields.highlightedElements?.value?.clickedObj?.length && selectedAction.fields.highlightedElements?.value?.neighbourObj?.length) {
                        return false;
                    }
                    break;
                case 'MAXIMIZE':
                    return false;
                default:
                    break;
            }
            return true;
        } else {
            return true;
        }
    }

    const addNewAction = async (action_name) => {
        if (desktopActiveItems[0]?.actionName === 'SCOPE') {
            let parentItemId = desktopActiveItems[0]?.item_id;
            const response = await ActionService.getActionByName(action_name);
            if (response && response.status) {

                const baseOrigin = await BASE_ORIGIN;
                let img = `${baseOrigin}/libraries/system/${response.data.library_version.library.image}`
                getImageColors(img, (result) => {
                    let shade = getShade(result.background, 75);


                    let new_action_detail = {
                        action_name: response.data.action_name,
                        action_label: response.data.action_label,
                        id: '',
                        flow_behavior: response.data.flow_behavior,
                        parent_id: response.data.parent_id,
                        status: true,
                        order: null,
                        visible: true,
                        libraryLabel: response.data.library_version.library.library_label,
                        libraryName: response.data.library_version.library.library_name,
                        application_id: response.data.library_version.library.application_id,
                        actionName: response.data.action_name,
                        library_label: response.data.library_version.library.library_label,
                        library_name: response.data.library_version.library.library_name,
                        image: img,
                        shade,
                        fields: {},
                        isDebugging: false,
                        debugStatus: "",
                        debugErrorMessage: "",
                        version: response.data.library_version.version,
                        versionId: response.data.library_version.id,
                        actionId: response.data.id
                    }

                    handleQuickActionClick({}, new_action_detail, parentItemId);
                })
            }
        }
    }

    return (
        <>
            {!isFullScreen && !openEdit && !openAddClicked.status && !openSimulatedScopeModal ? <div onClick={handleCloseDialog} className="dialog-desktop-actions-exit-icon"><Close /></div> : ""}
            <Dialog
                id="import-modal"
                open={true}
                PaperProps={{
                    style: {
                        minWidth: "93%",
                        height: "96%",
                        position: "relative",
                        marginLeft: "90px",
                        overflow: "visible"
                    },
                }}
            >

                <div className="new-flow-with-right new-flow-container dialog-desktop-actions">
                    {/* ------------------------Autom Preview Start------------------------ */}
                    <div className="dialog-column">
                        <h2>{t(label + "AUTOM-WORKSPACE")}</h2>
                        <p>{t(label + "AUTOM-WORKSPACE-DESCRIPTION")}</p>
                        <div className="new-flow-middle autom-preview-drop-area">
                            <MiddleArea
                                handleDragStart={handleDragStart}
                                automDetail={desktopAutomDetails}
                                triggerDetail={triggerDetail}
                                setTriggerDetail={setTriggerDetail}
                                operationId={operationId}
                                setAutomDetail={setDesktopAutomDetails}
                                handleTrigger={handleTrigger}
                                resetFlow={resetFlow}
                                saveFlow={saveFlow}
                                runFlow={runFlow}
                                debugFlow={debugFlow}
                                isEhFlow={isEhFlow}
                                editFlow={editFlow}
                                tabFilter={tabFilter}
                                setTabFilter={setTabFilter}
                                detailTabs={detailTabs}
                                setDetailTabs={setDetailTabs}
                                isFocused={tabFilter > 0}
                                setTriggerModal={setTriggerModal}
                                setOpenSchedule={setOpenSchedule}
                                trigger={trigger}
                                isRunning={isRunning}
                                triggerType={triggerType}
                                handleStart={handleStart}
                                handleStop={handleStop}
                                publishFlow={publishFlow}
                                setOpenDrive={setOpenDrive}
                                debuggingStart={debuggingStart}
                                setDebuggingExpand={setDebuggingExpand}
                                openRunningModal={openRunningModal}
                                setOpenDebugRunning={setOpenDebugRunning}
                                debuggingExpand={debuggingExpand}
                                handleRoi={handleRoi}
                                handleDiagramBuilder={handleDiagramBuilder}
                                findAndUpdateItem={findAndUpdateItem}
                                isDiagramBuilder={isDiagramBuilder}
                                diagramData={diagramData}
                                setIsDiagramBuilder={setIsDiagramBuilder}
                                setOpenRoi={setOpenRoi}
                                setShowRightArea={setShowRightArea}
                                setShowTriggerRightArea={setShowTriggerRightArea}
                                setIsWhatsappExist={setIsWhatsappExist}
                                setIsMSTeamsExist={setIsMSTeamsExist}
                                handleExport={handleExport}
                                handleImport={handleImport}
                                handleSlowMotion={handleSlowMotion}
                                setFlowStatus={setFlowStatus}
                                handleErrorOpenClick={handleErrorOpenClick}
                                handleErrorCloseClick={handleErrorCloseClick}
                                variables={variables}
                                setOpenVariable={setOpenVariable}
                                // action={actions[automDetail.activeItem[0]?.id]}
                                action={action}
                                setReCheck={setReCheck}
                                reCheck={reCheck}
                                openResetTriggerConfiguration={openResetTriggerConfiguration}
                                testAppStarted={testAppStarted}
                                handleTestAppCancel={handleTestAppCancel}
                                automaticallyVariableCreation={automaticallyVariableCreation}
                                automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                                getVariables={getVariables}
                                updateVariableByItemId={updateVariableByItemId}
                                setActiveItem={setDesktopActiveItem}
                                // setActiveItem={setDesktopActiveItems}
                                savedFlow={savedFlow}
                                isDesktopRecorder={true}
                                desktopActionsEditDialog={desktopActionsEditDialog}
                                handleDeleteAction={handleDeleteAction}
                                handleActions={handleActions}
                            />
                        </div>
                        {openEdit &&
                            <Dialog
                                id="edit-action"
                                open={true}
                                PaperProps={{
                                    style: {
                                        marginTop: "5%",
                                        gap: "5%",
                                        position: "relative",
                                        background: "transparent",
                                        height: "70%",
                                        width: "40%",
                                        borderRadius: "12px",
                                        maxWidth: "none",
                                        boxShadow: "none",
                                        transition: " opacity 0.3s",
                                        flexDirection: "row",
                                        overflowY: "visible",
                                        marginLeft: "35%"
                                    },
                                }}>
                                <Close className="close-edit-button" onClick={handleCloseEdit} />
                                {/* <div
                                    className={`action-container-border action-icon-border edit-action`}>
                                    <div
                                        id='flow-regular'
                                        className='new-flow-standard-item desktop-item-preview'
                                        draggable>
                                        <div
                                            style={selectedItem.shade ? { backgroundColor: selectedItem.shade } : {}}
                                            className={`${selectedItem.shade ? '' : 'color-' + selectedItem.libraryName.replace(/-/g, '_').replace(/ /g, '-').toLowerCase()} ${selectedItem.name === 'START' || selectedItem.name === 'STOP' || selectedItem.name === 'TRIGGER' ? '' : selectedItem.action_label.includes('CUSTOM') ? 'item-icon color-white' : 'item-icon color-yellow'}`}>


                                            <img style={{ width: 30 }} alt={selectedItem.libraryName}
                                                src={`${selectedItem.image}`} />

                                        </div>
                                        {
                                            selectedItem?.library_label?.includes('CUSTOM') ?
                                                (
                                                    <div
                                                        className={`${selectedItem.conditions && selectedItem.conditions.length && "wc"} action-item`}
                                                        style={{ textAlign: "center", position: "relative" }}>
                                                        <span className="action-item-lib">{selectedItem?.library_name}</span>
                                                        <span className="action-item-action">{selectedItem?.action_name}</span>
                                                    </div>

                                                ) :
                                                (
                                                    <div
                                                        className={`${selectedItem.conditions && selectedItem.conditions.length && "wc"} action-item`}
                                                        style={{ textAlign: "center", position: "relative" }}>
                                                        {selectedItem.name !== 'START' && selectedItem.name !== 'STOP' && selectedItem.name !== 'TRIGGER' &&
                                                            <>
                                                                <span
                                                                    className="action-item-lib">{t(`CONTENT.LIBRARY.${selectedItem.libraryName}.NAME`)}
                                                                </span>

                                                                <span className="action-item-action">{t('CONTENT.LIBRARY.' + selectedItem.libraryName + '.ACTION.' + selectedItem.name)}</span>
                                                            </>


                                                        }
                                                    </div>
                                                )
                                        }
                                    </div>
                                </div> */}
                                {
                                    !tempActions[selectedItem.id]?.libraryLabel?.includes('CUSTOM') && !tempActions[selectedItem.id]?.libraryLabel?.includes('CONDITION') &&
                                    <ConnectorField automDetail={desktopAutomDetails} action={tempActions[selectedItem.id]} showFieldPreview={true}
                                        triggerConfig={triggerConfig} triggerExpanded={true}
                                        debugOpen={false} debugExpand={false}
                                        onFlowPage={true}
                                        setTriggerConf={setTriggerConfig} automId={paramsId}
                                        automVersionId={automVersionId} rightLocation={false}
                                        variables={variables} setOpenVariable={setOpenVariable} resizeClassName="dialog-data-table" />
                                }
                                <DialogContent className={`new-flow-right desktop-flow-right ${tempActions[selectedItem.id]?.libraryLabel?.includes('CUSTOM') ? "custom-action-conf-content" : ""}`}>

                                    {/* <DialogTitle style={{ fontWeight: "700" }}>{t('CONTENT.LIBRARY.' + selectedItem.libraryName + '.ACTION.' + selectedItem.name)}</DialogTitle> */}
                                    <DialogTitle style={{ fontWeight: "700" }}>{selectedItem?.library_label?.includes('CUSTOM') ? selectedItem?.actionName :
                                        t('CONTENT.LIBRARY.' + selectedItem?.libraryName + '.ACTION.' + selectedItem?.name)}</DialogTitle>
                                    <RightArea
                                        setGroupLabel={setGroupLabel}
                                        actions={tempActions}
                                        // setSelected={setSelected}
                                        // selectedAction={actions[automDetail.activeItem[0]?.id]}
                                        selectedAction={tempActions[selectedItem.id]}
                                        //setSelected={setSelectedAction}
                                        mateId={automDetail?.mate_id}
                                        variables={variables}
                                        setVariables={setVariables}
                                        isEhFlow={isEhFlow}
                                        setOpenVariable={setOpenVariable}
                                        debuggingStart={debuggingStart}
                                        setDialog={setDialog}
                                        debuggingExpand={debuggingExpand}
                                        //variableRender={variableRender}
                                        automId={paramsId}
                                        automVersionId={automVersionId}
                                        recorder={recorder}
                                        //setRender={setRenderExt}
                                        drecorder={drecorder}
                                        fromFlow={false}
                                        automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                                        getVariables={getVariables}
                                        automDetail={desktopAutomDetails}
                                        setAutomDetail={setDesktopAutomDetails}
                                    />
                                    <Button
                                        size="medium"
                                        data-test="createuser-button"
                                        variant="outlined"
                                        style={{ backgroundColor: '#162436', color: '#fff', fontSize: 13, cursor: "pointer", width: "50%", marginTop: "30px", alignSelf: "end" }}
                                        onClick={handleSaveEdit}
                                    >
                                        {t(label + "BUTTON-SAVE")}
                                    </Button>
                                </DialogContent>
                            </Dialog>
                        }
                    </div >
                    {/* ------------------------Autom Preview End------------------------ */}

                    <div div className="desktop-actions-dividing-line" ></div >

                    {/* ------------------------Desktop Screen Preview Start------------------------ */}
                    <div div className="dialog-column desktop-screen-container" >
                        <h2>{t(label + "DESKTOP-SCREEN-PREVIEW")}</h2>
                        <p>{t(label + "DESKTOP-SCREEN-PREVIEW-DESCRIPTION")}</p>
                        <div className="screen-preview-area">

                            {
                                loading ?
                                    <DialogActions style={{ position: "absolute", top: '50%', left: "50%", transform: "translate(-50%, -50%)" }}><CircularProgress /></DialogActions>
                                    :
                                    desktopScreen ?
                                        <>
                                            <img src={desktopScreen} alt="ScopedImage" className="desktop-screen-image" />
                                            <Button className="desktop-screen-expand-button" onClick={handleMaximizeScreen}><img alt="fullscreen" src={maximizeIcon} /> <span>{t(label + "FULL-SCREEN")}</span> </Button>
                                        </>
                                        : <p className="no-screen">{t(label + "DESKTOP-SCREEN-EMPTY")}</p>
                            }
                        </div>
                    </div >
                    {/* ------------------------Desktop Screen Preview End------------------------ */}

                    {/* ------------------------Desktop Recorder Actions & Buttons Start------------------------ */}
                    <div className="dialog-column recorder-container">
                        <div className="desktop-actions-button-container">
                            <Button
                                className="desktop-actions-button simulate-button"
                                variant="outlined"
                                // disabled={(!(scopeActionChanged && scopeActionChanged.data?.elements) ||
                                //     !(desktopActiveItems && desktopActiveItems.length && tempActions[desktopActiveItems[0]?.id] && desktopActiveItems[0]?.id === scopeActionChanged.action.id))}
                                disabled={checkDisabledSimulate()}
                                // style={{
                                //     opacity: `${scopeActionChanged && scopeActionChanged.data?.elements && (desktopActiveItems && desktopActiveItems.length
                                //         && tempActions[desktopActiveItems[0]?.id] && desktopActiveItems[0]?.id === scopeActionChanged.action.id) ? "1" : "0.5"}`
                                // }}
                                onClick={handleSimulate}
                            >
                                {tempActions[desktopActiveItems[0]?.id]?.actionName === "SCOPE" ? t(label + "RE-TAKE-SCOPE") : t(label + "BUTTON-SIMULATE")}
                            </Button>
                            <Button
                                className="desktop-actions-button"
                                variant="outlined"
                                onClick={updateAutom}
                            >
                                {t(label + "BUTTON-SAVE-AS-DRAFT")}
                            </Button>
                        </div>
                        {/* ------------------------Buttons End------------------------ */}
                        <h2 style={{ marginBottom: "14px" }}>{t(label + "DESKTOP-RECORDER")}</h2>
                        <div className="desktop-recorder-container" >
                            <LeftArea
                                automType={automType}
                                handleDragStart={handleDragStart}
                                handleDragEnd={handleDragEnd}
                                variables={variables}
                                setVariables={setVariables}
                                setOpenVariable={setOpenVariable}
                                openVariable={openVariable}
                                automVersionId={automVersionId}
                                isDesktopRecorder={true}
                                openAddActionsByClickDialog={openAddActionsByClickDialog}
                            />
                        </div>
                        {/* ------------------------Desktop Recorder Actions End------------------------ */}
                    </div>
                </div >
                {
                    openAddClicked.status &&
                    <SelectAction save={(parentItemId) => { handleQuickActionClick({}, openAddClicked.clickedItem, parentItemId); setOpenAddClicked({ status: false }) }}
                        defaultItem={desktopActiveItems ? desktopActiveItems[0] : {}}
                        actions={desktopAutomDetails.items} close={() => setOpenAddClicked({ status: false })} />
                    // <Dialog
                    //     id="edit-action"
                    //     open={true}
                    //     PaperProps={{
                    //         style: {
                    //             display: "flex",
                    //             marginTop: "5%",
                    //             position: "relative",
                    //             gap: "2%",
                    //             background: "#FFFFFF",
                    //             height: "70%",
                    //             width: "40%",
                    //             borderRadius: "10px",
                    //             maxWidth: "none",
                    //             boxShadow: "none",
                    //             width: "33%",
                    //             height: "38%",
                    //             padding: "1.8% 2.5%",
                    //         },
                    //     }}>
                    //     <Close className="close-edit-button" onClick={handleCloseDialog} />
                    //     <h2 style={{ margin: "0" }}>Add Action</h2>
                    //     <p style={{ color: "#8F94A6", margin: "0" }}>Select where do you want to add selector in autom workflow</p>
                    //     {/* <hr style={{ width: "100%", marginLeft: "0", color: "#EBEBEB", backgroundColor: "#EBEBEB", height: "0.5px" }} /> */}
                    //     <div style={{ color: "#EBEBEB", border: "0.5px solid #EBEBEB", marginTop: "2%", marginBottom: "4%", width: "99%", alignSelf: "center" }} ></div>
                    //     <div style={{ height: "76px", borderRadius: "4px", border: "1px solid #EBEBEB", backgroundColor: "#FCFCFC", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    //         <Autocomplete
                    //             style={{
                    //                 backgroundColor: "#fff",
                    //                 height: "40px",
                    //                 fontSize: "12px",
                    //                 width: "90%"
                    //             }}
                    //             onChange={(event, value, reason) => {
                    //                 return handleChangeSelectedItem(value ? value : "")
                    //             }}
                    //             value={selectedAction.actionName}
                    //             id="demo-simple-select-outlined"
                    //             size="small"
                    //             options={desktopAutomDetails.flow.length > 0 ? desktopAutomDetails.flow : []}
                    //             getOptionLabel={(item) => {
                    //                 debugger
                    //                 if (item.name) {
                    //                     return item.name
                    //                 }
                    //                 return item
                    //             }}
                    //             renderInput={(params) => <TextField {...params} variant="outlined" />}
                    //         />
                    //     </div>
                    //     <Button style={{ backgroundColor: "#8F94A6", color: "#FFFFFF", width: "45%", alignSelf: "center", marginTop: "10%" }}>Add</Button>
                    // </Dialog>
                }

                {
                    isRunningSimulate &&
                    <SimulateModal checkSimulatePendingMessage={checkSimulatePendingMessage} />
                }
                {/* ------------------------Fullscreen Desktop SS Start------------------------ */}
                {
                    isFullScreen ?
                        <Dialog
                            id="import-modal"
                            open={true}
                            PaperProps={{
                                style: {
                                    height: "89.5%",
                                    width: "89%",
                                    position: "relative",
                                    marginLeft: "90px",
                                    overflow: "visible",
                                    display: "flex",
                                    flexDirection: "row",
                                    borderRadius: "12px",
                                    backgroundColor: "transparent",
                                    maxWidth: "none",
                                    gap: "50px",
                                    backdropFilter: "blur(3px)",
                                    boxShadow: "none",
                                    transition: " opacity 0.3s",
                                    alignItems: "flex-start"
                                },
                            }}
                        >
                            <DialogContent className="quick-ui-actions-container">
                                <div>
                                    {/* <h2 style={{ textAlign: "center" }}>{t('CONTENT.LIBRARY.' + selectedItem.libraryName + '.ACTION.' + selectedItem.name)}</h2> */}
                                    <h2 style={{ textAlign: "center" }}>{desktopActiveItems[0]?.library_label?.includes('CUSTOM') ? desktopActiveItems[0]?.action_name : t('CONTENT.LIBRARY.' + desktopActiveItems[0]?.libraryName + '.ACTION.' + desktopActiveItems[0]?.actionName)}</h2>
                                    <DialogTitle className="quick-ui-actions-header">
                                        <img src={uiActionsIcon} alt="uiActionIcon" />
                                        <span>{t(label + "QUICK-UI-ACTIONS")}</span>
                                    </DialogTitle>
                                </div>
                                <DialogContent className="quick-ui-actions-button-container">
                                    <Button onClick={() => addNewAction('CROP-IMAGE')}
                                        disabled={desktopActiveItems[0]?.actionName !== 'SCOPE' && desktopActiveItems[0]?.actionName !== "CROP-IMAGE"}>
                                        {/* <img loading="lazy" src={quickActionsLibrary.image} /> */}
                                        <img alt="get-text" loading="lazy" src={quickActionsLibrary.image?.includes('data:') ? quickActionsLibrary.image :
                                            `${baseOrigin}/libraries/${quickActionsLibrary.is_system ? "system" : "custom"}/${quickActionsLibrary.image ? quickActionsLibrary.image : defaultLibraryImg}`} />
                                        <span className="module-item-title">Crop Image</span>
                                    </Button>
                                    <Button onClick={() => addNewAction('GET-TEXT')}
                                        disabled={desktopActiveItems[0]?.actionName !== 'SCOPE' && desktopActiveItems[0]?.actionName !== "GET-TEXT"}>
                                        {/* <img loading="lazy" src={quickActionsLibrary.image} /> */}
                                        <img alt="anchor" loading="lazy" src={quickActionsLibrary.image?.includes('data:') ? quickActionsLibrary.image :
                                            `${baseOrigin}/libraries/${quickActionsLibrary.is_system ? "system" : "custom"}/${quickActionsLibrary.image ? quickActionsLibrary.image : defaultLibraryImg}`} />
                                        <span className="module-item-title">Get Text</span>
                                    </Button>
                                    <Button onClick={() => addNewAction('FIND-AND-CLICK')}
                                        disabled={desktopActiveItems[0]?.actionName !== 'SCOPE' && desktopActiveItems[0]?.actionName !== "FIND-AND-CLICK"}>
                                        {/* <img loading="lazy" src={quickActionsLibrary.image} /> */}
                                        <img alt="find-and-click" loading="lazy" src={quickActionsLibrary.image?.includes('data:') ? quickActionsLibrary.image :
                                            `${baseOrigin}/libraries/${quickActionsLibrary.is_system ? "system" : "custom"}/${quickActionsLibrary.image ? quickActionsLibrary.image : defaultLibraryImg}`} />
                                        <span className="module-item-title">Find & Click</span>
                                    </Button>
                                    <Button onClick={() => addNewAction('FIND-AND-INPUT')}
                                        disabled={desktopActiveItems[0]?.actionName !== 'SCOPE' && desktopActiveItems[0]?.actionName !== "FIND-AND-INPUT"}>
                                        {/* <img loading="lazy" src={quickActionsLibrary.image} /> */}
                                        <img alt="find-and-input" loading="lazy" src={quickActionsLibrary.image?.includes('data:') ? quickActionsLibrary.image :
                                            `${baseOrigin}/libraries/${quickActionsLibrary.is_system ? "system" : "custom"}/${quickActionsLibrary.image ? quickActionsLibrary.image : defaultLibraryImg}`} />
                                        <span className="module-item-title">Find & Input</span>
                                    </Button>
                                </DialogContent>
                            </DialogContent>
                            {/* ------------------------FIND-AND-CLICK Capture Area Start------------------------ */}
                            {tempActions[desktopActiveItems[0]?.id] && (
                                ["FIND-AND-CLICK", "FIND-AND-INPUT", "PAGINATION", "HOVER", "SMOOTH-SCROLL", "GET-TEXT", "PAGINATION-ITEM", "CROP-IMAGE", "ELEMENT-EXIST"].includes(desktopActiveItems[0]?.actionName)) ?
                                <CaptureArea
                                    automDetail={desktopAutomDetails}
                                    setAutomDetail={setDesktopAutomDetails}
                                    action={tempActions[desktopActiveItems[0].id]}
                                    upImg={desktopScreen}
                                    isGrid={0}
                                    isVariableShow={false}
                                    clickDiv={null}
                                    imageEnlarged={imageEnlarged}
                                    handleScale={handleScale}
                                    actions={tempActions}
                                    drecorder={drecorder}
                                    getVariables={getVariables}
                                    recorder={recorder}
                                    variables={variables}
                                    setVariables={setVariables}
                                    setOpenVariable={setOpenVariable}
                                    handleCloseDialog={handleCloseDialog}
                                    paginationArea={paginationArea}
                                    setPaginationArea={setPaginationArea}
                                    uniqueColumnAreas={uniqueColumnAreas}
                                    setUniqueColumnAreas={setUniqueColumnAreas}
                                    activeAreaSelector={activeAreaSelector}
                                    items={JSON.parse(JSON.stringify(desktopAutomDetails.items))} />
                                :
                                (
                                    <>
                                        <div onClick={handleCloseDialog} className="dialog-desktop-actions-exit-icon exit-fullscreen-icon"><Close /></div>
                                        <img alt="full screen image" className={`${imageEnlarged ? "enlarged" : ""} fullscreen-image`} style={handleScale()} src={desktopScreen} />
                                        <Guide
                                            isScope={true}
                                        />
                                    </>
                                )

                            }
                            {/* ------------------------FIND-AND-CLICK Capture Area End------------------------ */}


                        </Dialog> : ""
                }

                {openSimulatedScopeModal && modalSS.dataString && <NewScopeModal modalSS={modalSS.dataString} handleAddNewScope={handleAddNewScope} setOpenSimulatedScopeModal={setOpenSimulatedScopeModal} />}
            </Dialog >
            {/* ------------------------Fullscreen Desktop SS End------------------------ */}
        </>
    );
};

export default DesktopActions;
